'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

type Props = { locale: string };

// The return-to stays in its cookie, so a plain login link still leads back to the invitation.
export function EmailTakenNotice({ locale }: Props) {
  const t = useTranslations('auth.register.invited');

  return (
    <div role="alert" className="flex flex-col gap-1 text-center text-label">
      <p className="text-destructive">{t('emailTaken')}</p>
      <Link
        href={`/${locale}/login`}
        className="text-foreground underline underline-offset-4 hover:no-underline"
      >
        {t('goToLogin')}
      </Link>
    </div>
  );
}
